import * as moment from 'moment';

export default {
  toastTimer: 3000,
  minDate: '2000-01-01',
  currentDate: moment().format('YYYY-MM-DD'),
  maxDate: moment()
    .subtract(1, 'year')
    .calendar(),
  chitMonth: 20,
  gender: ['Male', 'Female', 'Other'],
  maritalStatus: ['Married', 'Single', 'Divorced', 'Widow'],
  paymentMode: ['Net Banking', 'Cheque', 'Cash', 'Other'],
  monthlyPaymentMode: ['Net Banking', 'Cheque', 'Cash', 'Adjustment', 'Other'],
  chittieStatus: ['All Chitties', 'Active Chitties', 'Inactive Chitties'],
  userStatus: ['All Users', 'Active Users', 'Inactive Users'],
  receiptStatus: ['All Bills', 'Active Bills', 'Cancelled Bills'],
  companyName: 'VETTRI VELA CHIT FUND (P) LTD.,',
  cinNumber: 'CIN : U67100TZ2016PTC027951',
  companyAddress: '13/22-B (3), 2nd  Street  -  Anna Nagar – Kinathukadavu-642 109 – Coimbatore District',
  perPage: 10
};



// WEBPACK FOOTER //
// ./src/config/constants.js